import type { IData } from "~/interfaces";
import { updateStateValue } from "~/utils";
import { rataRoute } from "~/themes/credito/utils/redirects";

export default defineNuxtRouteMiddleware((to) => {
    if (!to.query.amount || to.path !== '/' ) return;

    const credit: number = +(to.query.amount as string);
    const data: IData = getThemeData();

    if (data.values.prices.find(price => price.imp_credito == credit)) {
        updateStateValue('allowForms', true);
        updateStateValue("selectedCredit", credit)
        delete to.query.amount
        return navigateTo({
            path: rataRoute({selectUpgrade: false}),
            query: to.query
        })
    }
})